// extracted by mini-css-extract-plugin
module.exports = {"title":"ElectronVersion_title__3MB96","grid":"ElectronVersion_grid__1gyrV","card":"ElectronVersion_card__2i9I9","link":"ElectronVersion_link__3oWfT"};